<ng-template #content>
  <ng-content></ng-content>
</ng-template>
<myqq-mobile-layout
  *ngIf="isMobile | async"
  [homeLink]="homeLink"
  [accountLinks]="mobileAccountLinks"
  [accountLinked]="accountLinked$"
  [referralLink]="(enableFriendBuy$ | async) ? referralLink : null"
  [authenticated]="allowAccess$"
  [online]="online$ | async"
  [greenBackground]="greenBackground"
  (authenticate)="handleAuthentication($event)"
  (register)="handleRegister()"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</myqq-mobile-layout>

<myqq-desktop-layout
  *ngIf="!(isMobile | async)"
  [homeLink]="homeLink"
  [accountLinks]="accountLinks"
  [accountLinked]="accountLinked$"
  [referralLink]="(enableFriendBuy$ | async) ? referralLink : null"
  [authenticated]="allowAccess$"
  [online]="online$ | async"
  (authenticate)="handleAuthentication($event)"
  (register)="handleRegister()"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</myqq-desktop-layout>
